import axiosInstance from "src/common/axiosInstance";

/**
 * Meta-side billing / capacity for a WhatsApp account:
 * send limits, quality, message + conversation analytics, payment signal.
 */
const usageService = {
  get(workspaceId, accountId, { days = 30, refresh = false } = {}) {
    return axiosInstance.get(
      `/workspaces/${workspaceId}/whatsapp-accounts/${accountId}/usage`,
      { params: { days, ...(refresh ? { refresh: 1 } : {}) } },
    );
  },
};

export default usageService;
